export default function({store}) {
  if (store.$auth.loggedIn && !store.getters['offline/isOffline']) {
    store.dispatch(`notificaciones/list`)
  }
}
